import TinyColor2 from 'tinycolor2';

export default (rawColor, opacity) => {
    const color = rawColor?.setAlpha ? rawColor : new TinyColor2(rawColor);

    return color.setAlpha(opacity);
};
